"use client";

import { c as _c } from "react/compiler-runtime";
import { AlertTriangle, CheckCircle2, Info, Loader2, XCircle } from "lucide-react";
import { useTheme } from "next-themes";
import { Toaster as Sonner, type ToasterProps } from "sonner";
import { useIsMobile } from "@/hooks/use-mobile";
const Toaster = t0 => {
  const $ = _c(9);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  const {
    theme: t1
  } = useTheme();
  const theme = t1 === undefined ? "system" : t1;
  const isMobile = useIsMobile();
  const t2 = theme as ToasterProps["theme"];
  const t3 = isMobile ? "top-center" : "top-right";
  let t4;
  let t5;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      success: <CheckCircle2 className="size-5 text-primary" />,
      error: <XCircle className="size-5 text-destructive" />,
      info: <Info className="size-5 text-sky-500" />,
      warning: <AlertTriangle className="size-5 text-amber-500" />,
      loading: <Loader2 className="size-5 animate-spin text-muted-foreground" />
    };
    t5 = {
      classNames: {
        toast: "group !flex !w-full md:!max-w-[380px] !items-start !gap-3 !overflow-hidden !rounded-xl !border !border-border/70 !bg-popover !p-4 !text-foreground !shadow-lg !shadow-black/5",
        title: "!line-clamp-3 !break-words !text-sm !font-semibold !text-foreground",
        description: "!mt-0.5 !line-clamp-2 !break-words !overflow-hidden !text-xs !text-muted-foreground",
        icon: "!mt-0.5 !shrink-0",
        closeButton: "!border-border/70 !bg-popover !text-muted-foreground hover:!text-foreground"
      }
    };
    t6 = {
      "--width": "380px"
    };
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
  } else {
    t4 = $[2];
    t5 = $[3];
    t6 = $[4];
  }
  let t7;
  if ($[5] !== props || $[6] !== t2 || $[7] !== t3) {
    t7 = <Sonner theme={t2} className="toaster group" position={t3} duration={4000} expand={true} visibleToasts={3} icons={t4} toastOptions={t5} style={t6 as React.CSSProperties} {...props} />;
    $[5] = props;
    $[6] = t2;
    $[7] = t3;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
};
export { Toaster };